import React from "react";
import { Menu, MenuButton, MenuDivider, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPreset, setPreset } from "../redux/locationsSelectorSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { IconDots, Edit, Trash, TextIcon } from "../../../../../assets/images/svg";

export const Preset = ({ openEdit, handlePopup, type = "regular", title = "Presets" }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.locations.presets[type]);
  const preset = useSelector((state) => state.locations.selectedPreset);
  const selectedPreset = preset && preset[0].type === type ? preset : null;

  const onOptionsChange = (data) => {
    dispatch(setPreset({ type, ...data }));
  };

  const onEdit = (item) => {
    dispatch(setCurrentPreset({ type, ...item }));
    openEdit();
  };

  const onMenuClick = ({ value, syntheticEvent }, item) => {
    syntheticEvent.preventDefault();

    if (value == "rename" || value == "delete") {
      handlePopup(item, value, type);
    } else {
      onEdit(item);
    }
  };

  const menu = () => (
    <>
      <MenuItem value="rename">
        <TextIcon />
        <span>Rename</span>
      </MenuItem>
      <MenuItem value="edit" className="edit">
        <Edit />
        <span>Edit</span>
      </MenuItem>
      <MenuDivider />
      <MenuItem value="delete">
        <Trash color="#FF0000" />
        <span>Delete</span>
      </MenuItem>
    </>
  );

  const renderMenu = (item) => {
    return (
      <Menu
        menuButton={
          <MenuButton>
            <IconDots />
          </MenuButton>
        }
        onItemClick={(eventObj) => onMenuClick(eventObj, item)}
        direction="right"
        align="start"
        transition
        portal={{ target: document.querySelector(".filter.filter-preset") }}
      >
        {menu(item.id)}
      </Menu>
    );
  };

  const renderList = ({ id, item, isSelected, selectValue, labelKey, valueKey }) => {
    const cssClass = isSelected ? "option selected" : "option";

    return (
      <div className="filter-preset__el" key={item[valueKey]}>
        <div
          id={id}
          role="option"
          data-testid="option"
          data-selected={isSelected ? "selected" : ""}
          aria-selected={isSelected}
          className={cssClass}
          onClick={() => selectValue(item)}
          onKeyPress={(e) => {
            e.preventDefault();
            selectValue(item);
          }}
        >
          <input
            type="checkbox"
            readOnly
            tabIndex={-1}
            checked={isSelected}
            data-testid="option-checkbox"
          />
          {item[labelKey]}
        </div>
        <div className="filter-preset__menu">{renderMenu(item)}</div>
      </div>
    );
  };

  return (
    <div className="filter filter-preset">
      <p>{title}</p>
      {options.length === 0 ? (
        <div className="picky">
          <div className="picky__input">There is no preset</div>
        </div>
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedPreset ?? []}
          placeholder="Not selected"
          includeFilter={!!options.length}
          numberDisplayed={0}
          multiple={false}
          haveOnSelectChange
          onSelectChange={(data) => onOptionsChange(data)}
          render={renderList}
        />
      )}
    </div>
  );
};
